module.exports = __webpack_public_path__ + "media/images/front/common/icon_event-f6b067f68eba05fc33e7bd2738e9bb9e.svg";